var _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDish2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_358_278)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50.418,
    r: 25,
    fill: "#98BCD6"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50.418,
    r: 35,
    fill: "#98BCD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0693 45.5976C34.268 49.7948 37.6255 52.4012 40.845 54.0172C45.9901 56.5996 51.5276 56.9256 56.7604 54.9982L56.8555 54.9634",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8096 53.5996C62.7699 51.9636 65.7678 49.4546 67.7868 45.614",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6934 44.9346C27.4968 45.9001 28.3061 46.8587 29.1174 47.8152C33.1878 52.6147 37.1469 57.3358 42.4516 60.1976C47.5465 62.9463 52.4408 62.9533 57.5489 60.1975C62.8536 57.3358 66.8126 52.6147 70.8831 47.8152C71.6943 46.8587 72.5036 45.9001 73.3071 44.9346",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4175 46.5525V49.6709C45.4175 50.1654 45.8184 50.5664 46.313 50.5664H49.0851C49.5796 50.5664 49.9806 50.1654 49.9806 49.6709V46.6443",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9878 46.6443V49.6709C49.9878 50.1655 50.3888 50.5664 50.8833 50.5664H53.6555C54.15 50.5664 54.5509 50.1655 54.5509 49.6709V46.5525",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.583 46.5525V49.7945C54.583 50.2208 54.9287 50.5664 55.3549 50.5664H57.7444C58.1707 50.5664 58.5163 50.2208 58.5163 49.7945V46.3708",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5161 46.372V48.4826C58.5161 48.8859 58.8431 49.2129 59.2464 49.2129H61.5072C61.9106 49.2129 62.2376 48.8859 62.2376 48.4826V46.1214",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4177 46.5525V49.7945C45.4177 50.2208 45.072 50.5664 44.6457 50.5664H42.2562C41.8299 50.5664 41.4844 50.2208 41.4844 49.7945V46.3708",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4842 46.3721V48.4826C41.4842 48.8859 41.1572 49.2129 40.7539 49.2129H38.4931C38.0897 49.2129 37.7627 48.8859 37.7627 48.4826V46.1214",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4426 37.5509C44.3599 36.4853 47.3402 36.2931 50.0002 38.608C55.1947 34.0875 61.6108 39.1278 66.3934 41.5619C68.6782 42.7248 71.0024 43.7989 73.2973 44.9392C73.2973 44.9392 62.2395 46.5877 50.0099 46.6443V46.6445C50.0067 46.6445 50.0035 46.6444 50.0002 46.6444C49.997 46.6444 49.9937 46.6445 49.9904 46.6445V46.6443C37.7608 46.5877 26.7031 44.9392 26.7031 44.9392C28.998 43.7989 31.3222 42.7248 33.607 41.5619C35.0677 40.8184 36.6807 39.832 38.3649 38.949L38.5073 38.8746",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3604 60.462C65.0563 61.1069 64.1755 62.6818 62.6234 63.2176C62.5031 63.2591 62.5031 63.4302 62.6234 63.4718C64.1755 64.0075 65.0563 65.5824 65.3604 66.2273C65.4091 66.3305 65.556 66.3305 65.6047 66.2273C65.9088 65.5824 66.7896 64.0075 68.3417 63.4718C68.462 63.4302 68.462 63.2591 68.3417 63.2176C66.7896 62.6818 65.9088 61.1069 65.6047 60.462C65.556 60.3589 65.4091 60.3589 65.3604 60.462Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4625 28.1852C35.0436 29.0735 33.8305 31.2427 31.6927 31.9805C31.5269 32.0377 31.5269 32.2734 31.6927 32.3305C33.8305 33.0684 35.0436 35.2376 35.4625 36.1258C35.5295 36.268 35.7318 36.268 35.7988 36.1258C36.2177 35.2376 37.4308 33.0684 39.5686 32.3305C39.7343 32.2734 39.7343 32.0377 39.5686 31.9805C37.4308 31.2427 36.2177 29.0735 35.7988 28.1852C35.7318 28.0431 35.5295 28.0431 35.4625 28.1852Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.441 64.7086C58.0221 65.5969 56.809 67.7661 54.6712 68.5039C54.5054 68.5611 54.5054 68.7968 54.6712 68.854C56.809 69.5918 58.0221 71.7611 58.441 72.6493C58.5079 72.7914 58.7103 72.7914 58.7773 72.6493C59.1962 71.7611 60.4093 69.5918 62.5471 68.854C62.7128 68.7968 62.7128 68.5611 62.5471 68.5039C60.4093 67.7661 59.1962 65.5969 58.7773 64.7086C58.7103 64.5665 58.5079 64.5665 58.441 64.7086Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_358_278",
    x: 0,
    y: 0.417969,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_358_278"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish2);
export default __webpack_public_path__ + "static/media/dish2.4f13a6f1be7cb12842bb5b9c6d18b893.svg";
export { ForwardRef as ReactComponent };